import axios from "axios";
import { getStorageItems } from "../utils/constants";
import { supabase } from "../lib/supabase";

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

client.interceptors.request.use(
  function (config) {
    const customData = getStorageItems();
    Object.assign(config.headers, customData);
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

client.interceptors.response.use(
  function (response) {
    return { ...response };
  },
  async function (err) {
    const path = window.location.pathname;
    const isPublicAuthPage =
      path === "/login" ||
      path === "/forgot-password" ||
      path === "/reset-password";

    const original = err?.config;

    if (err?.response?.status === 401 && !isPublicAuthPage) {
      // Ante un 401, intentamos UN refresh del token y reintentamos la request.
      // Solo si el refresh falla de verdad cerramos sesión (evita el logout por
      // token vencido cuando la sesión sigue siendo válida).
      if (original && !original._retried) {
        original._retried = true;
        try {
          const { data, error } = await supabase.auth.refreshSession();
          const token = data?.session?.access_token;
          if (!error && token) {
            sessionStorage.setItem("Authorization", token);
            original.headers = original.headers || {};
            original.headers.Authorization = `Bearer ${token}`;
            return client(original);
          }
        } catch (e) {
          // cae al cierre de sesión de abajo
        }
      }
      sessionStorage.clear();
      localStorage.removeItem("voras:mfa_verified_at");
      window.location.reload();
    }
    return Promise.reject(err);
  }
);

export default client;
